/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_string_pattern = /** @type {(inputs: {}) => string} */ () => {
	return `Vzor řetězce`
};

const da_attributes_string_pattern = /** @type {(inputs: {}) => string} */ () => {
	return `Planen for opstrengning`
};

const de_attributes_string_pattern = /** @type {(inputs: {}) => string} */ () => {
	return `Besaitungsmuster`
};

const en_attributes_string_pattern = /** @type {(inputs: {}) => string} */ () => {
	return `String Pattern`
};

const es_attributes_string_pattern = /** @type {(inputs: {}) => string} */ () => {
	return `plan de encordado`
};

const fr_attributes_string_pattern = /** @type {(inputs: {}) => string} */ () => {
	return `Plan de cordage`
};

const hu_attributes_string_pattern = /** @type {(inputs: {}) => string} */ () => {
	return `Fúróterv`
};

const it_attributes_string_pattern = /** @type {(inputs: {}) => string} */ () => {
	return `piano di incordatura`
};

const nl_attributes_string_pattern = /** @type {(inputs: {}) => string} */ () => {
	return `bespanplan`
};

const pl_attributes_string_pattern = /** @type {(inputs: {}) => string} */ () => {
	return `plan naciągania`
};

const pt_attributes_string_pattern = /** @type {(inputs: {}) => string} */ () => {
	return `plano de encordoamento`
};

const sv_attributes_string_pattern = /** @type {(inputs: {}) => string} */ () => {
	return `planen för strängning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_string_pattern = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_string_pattern(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_string_pattern", locale)
	if (locale === "cs") return cs_attributes_string_pattern(inputs)
	if (locale === "da") return da_attributes_string_pattern(inputs)
	if (locale === "de") return de_attributes_string_pattern(inputs)
	if (locale === "en") return en_attributes_string_pattern(inputs)
	if (locale === "es") return es_attributes_string_pattern(inputs)
	if (locale === "fr") return fr_attributes_string_pattern(inputs)
	if (locale === "hu") return hu_attributes_string_pattern(inputs)
	if (locale === "it") return it_attributes_string_pattern(inputs)
	if (locale === "nl") return nl_attributes_string_pattern(inputs)
	if (locale === "pl") return pl_attributes_string_pattern(inputs)
	if (locale === "pt") return pt_attributes_string_pattern(inputs)
	return sv_attributes_string_pattern(inputs)
};
export { attributes_string_pattern as "attributes.string_pattern" }